import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import * as Sentry from "@sentry/react";

import { PrivateRoutes, PublicRoutes } from "./Routes";
import DefaultLayout from "@/layouts/DefaultLayout";
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout";
import ErrorBoundary from "@/layouts/ErrorBoundary";
import ProtectedRoute from "@/router/ProtectedRoute";
import NavigationBlocker from "@/components_v2/Guards/NavigationBlocker.js";
import { AnalyticsTracker } from "@/libraries/analytics";

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const wrapWithSentryErrorBoundary = (Component, props = {}) => (
  <Sentry.ErrorBoundary fallback={<ErrorBoundary />}>
    <Component {...props} />
  </Sentry.ErrorBoundary>
);

const RootWrapper = () => (
  <>
    <NavigationBlocker />
    <AnalyticsTracker />
    <Outlet />
  </>
);

const router = sentryCreateBrowserRouter([
  {
    element: <RootWrapper />,
    children: [
      {
        element: wrapWithSentryErrorBoundary(DefaultLayout),
        children: [
          ...PublicRoutes.map((route) => ({
            path: route.path,
            element: wrapWithSentryErrorBoundary(route.view),
          })),
        ],
      },
      {
        element: wrapWithSentryErrorBoundary(AuthenticatedLayout),
        children: [
          ...PrivateRoutes.map((route) => ({
            path: route.path,
            element: (
              <ProtectedRoute
                element={wrapWithSentryErrorBoundary(route.view, route?.props)}
                roles={route.allowedRoles || []}
                organizationRoles={route.allowedOrgRoles || []}
              />
            ),
          })),
        ],
      },
      { path: "*", element: <Navigate to="/login" /> },
    ],
  },
]);

export default router;
